const POS = {
  tl: "top-0 left-0 -translate-x-[18%] -translate-y-[18%]",
  tr: "top-0 right-0 translate-x-[18%] -translate-y-[18%] -scale-x-100",
  bl: "bottom-0 left-0 -translate-x-[18%] translate-y-[18%] -scale-y-100",
  br: "bottom-0 right-0 translate-x-[18%] translate-y-[18%] rotate-180",
};

export const Floral = ({ pos = "tl", className = "w-40 sm:w-56 lg:w-72", opacity = "opacity-90" }) => (
  <img
    src="/images/ftl.png"
    alt=""
    aria-hidden="true"
    loading="lazy"
    className={`pointer-events-none select-none absolute z-0 ${POS[pos]} ${className} ${opacity}`}
  />
);
